// userDataSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../../api";

export const fetchBonus = createAsyncThunk("bonus/fetchBonus", async () => {
  const response = await api.post("/bonus");
  return response.data.data;
});

export const addBonus = createAsyncThunk(
  "bonus/addBonus",
  async (bonusData, { dispatch, rejectWithValue }) => {
    try {
      const response = await api.post("/add-bonus", bonusData);
      dispatch(fetchBonus());
      dispatch(closeBonusModal());
      return response.data.message;  // Assuming success message is in the response data
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Failed to save bonus record");
    }
  }
);


export const deleteBonus = createAsyncThunk(
  "bonus/deleteBonus",
  async (bonusId, { dispatch, rejectWithValue }) => {
    try {
      const response = await api.post(`/delete-bonus/${bonusId}`);
      dispatch(fetchBonus());
      return response.data.message;  
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Failed to delete bonus record");
    }
  }
);

// Slice
const bonusSlice = createSlice({
  name: "bonusData",
  initialState: {
    data: [],
    loading: false,
    isModalOpen: false,
    selectedUserId: null,
    addLoading: false,
    deleteLoading: false,
    error: null,
    successMessage: null,  // To store success messages from backend
  },
  reducers: {
    openBonusModal: (state, action) => {
      state.isModalOpen = true;
      state.selectedUserId = action.payload || null;
    },
    closeBonusModal: (state) => {
      state.isModalOpen = false;
      state.selectedUserId = null;
      state.error = null;
      state.successMessage = null;  
    },
    clearError: (state) => {
      state.error = null;
      state.successMessage = null;  
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchBonus.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchBonus.fulfilled, (state, action) => {
        state.data = action.payload;
        state.loading = false;
      })
      .addCase(fetchBonus.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(addBonus.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(addBonus.fulfilled, (state, action) => {
        state.addLoading = false;
        state.successMessage = action.payload;
      })
      .addCase(addBonus.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action.payload;
      })
      .addCase(deleteBonus.pending, (state) => {
        state.deleteLoading = true;
      })
      .addCase(deleteBonus.fulfilled, (state, action) => {
        state.deleteLoading = false;
        state.successMessage = action.payload;
      })
      .addCase(deleteBonus.rejected, (state, action) => {
        state.deleteLoading = false;
        state.error = action.payload;
      });
  },
});

export const { openBonusModal, closeBonusModal, clearError } = bonusSlice.actions;
export default bonusSlice.reducer;
export { bonusSlice };
